import axios from "axios";
import { cloneDeep } from "lodash";
import { triggerPriceMatchErrors } from "../../useAnalyticsHooks";
import { ELEMENTS } from "../../utils";
import { initialState } from "./store";

export const handleResetState = (state, elementId) => {
  const initialStateWithCommonValues = {
    ...initialState,
    [ELEMENTS.CHECK_QUALIFY]: state[ELEMENTS.CHECK_QUALIFY],
    [ELEMENTS.LOWER_PRICE_RETAILER]: state[ELEMENTS.LOWER_PRICE_RETAILER],
  };

  switch (elementId) {
    case ELEMENTS.CHECK_QUALIFY:
      return initialState;
    case ELEMENTS.LOWER_PRICE_RETAILER:
      return initialStateWithCommonValues;
    case ELEMENTS.PURCHASED_FROM:
      return {
        ...initialStateWithCommonValues,
        [ELEMENTS.PURCHASED_FROM]: state[ELEMENTS.PURCHASED_FROM],
      };
    case ELEMENTS.PURCHASED_SHOP:
      return {
        ...initialStateWithCommonValues,
        [ELEMENTS.PURCHASED_FROM]: state[ELEMENTS.PURCHASED_FROM],
        [ELEMENTS.PURCHASED_SHOP]: state[ELEMENTS.PURCHASED_SHOP],
      };
    case ELEMENTS.PURCHASED_PAYMENT_MODE:
      return {
        ...initialStateWithCommonValues,
        [ELEMENTS.PURCHASED_FROM]: state[ELEMENTS.PURCHASED_FROM],
        [ELEMENTS.PURCHASED_SHOP]: state[ELEMENTS.PURCHASED_SHOP],
        [ELEMENTS.PURCHASED_PAYMENT_MODE]: state[ELEMENTS.PURCHASED_PAYMENT_MODE],
      };
    case ELEMENTS.PURCHASED_DATE:
      return {
        ...initialState,
        [ELEMENTS.CHECK_QUALIFY]: state[ELEMENTS.CHECK_QUALIFY],
        [ELEMENTS.LOWER_PRICE_RETAILER]: state[ELEMENTS.LOWER_PRICE_RETAILER],
        ...(state[ELEMENTS.PURCHASED_FROM] === "shop" && {
          [ELEMENTS.PURCHASED_SHOP]: state[ELEMENTS.PURCHASED_SHOP],
          [ELEMENTS.PURCHASED_PAYMENT_MODE]: state[ELEMENTS.PURCHASED_PAYMENT_MODE],
        }),
      };
    default:
      return { ...state };
  }
};

export const buildPayloadData = responses => {
  const data = {
    caseData: {
      webForm: "NKU",
      priceDropSubject: `Post Purchase - ${responses[ELEMENTS.LOWER_PRICE_RETAILER]}`,
      origin: "Web",
    },
    shopAttachments: [],
    priceProofAttachments: [],
  };

  // eslint-disable-next-line no-unused-vars
  const { [ELEMENTS.CHECK_QUALIFY]: _, [ELEMENTS.PURCHASED_PAYMENT_MODE]: __, ...caseData } = cloneDeep(responses);

  Object.keys(caseData).forEach(key => {
    if (![ELEMENTS.RECEIPT_PHOTOS, ELEMENTS.LOWER_PRICE_PHOTOS].includes(key)) {
      data.caseData[key] = caseData[key];
    } else if (key === ELEMENTS.RECEIPT_PHOTOS) {
      data.shopAttachments = caseData[key].attachments;
    } else if (key === ELEMENTS.LOWER_PRICE_PHOTOS) {
      data.priceProofAttachments = caseData[key].attachments;
    }
  });

  return data;
};

const prepareFormData = state => {
  const { caseData, shopAttachments, priceProofAttachments } = buildPayloadData(state);
  const formData = new FormData();

  formData.append("caseData", JSON.stringify(caseData));
  shopAttachments.forEach((attachment, index) => formData.append(`shop-receipt-${index + 1}`, attachment.file));
  priceProofAttachments.forEach((attachment, index) => formData.append(`price-proof-${index + 1}`, attachment.file));

  return formData;
};

const handleErrorResponse = (error, setServerError, onComplete) => {
  let body;
  let title = "Sorry, your refund request was not submitted.";

  if (error.response) {
    body = "Due to a technical error, we were not able to submit your price promise refund request. Please try again.";
  } else if (error.request) {
    title = "Sorry, we've lost connection.";
    body = "Please try submitting the form again.";
  } else {
    body = "There's been a technical problem. Please try again later.";
  }
  triggerPriceMatchErrors({ "form-submission-failed": title });
  setServerError({ title, body });
  onComplete();
};

export const postFormData = ({ state, router, onComplete, setServerError }) => {
  setServerError(null);
  const formData = prepareFormData(state);
  axios
    .post(`${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/email-us/v1/price-match-case`, formData)
    .then(resp => {
      if (resp.data.caseNumber) {
        router.push({ pathname: "/prices-and-payment/price-promise/confirmation", query: router.query });
      }
      onComplete();
    })
    .catch(error => handleErrorResponse(error, setServerError, onComplete));
};
